module.exports = __webpack_public_path__ + "media/assets/icons/left-caret-38c786213d4a9800d902a8625444f274.svg";